export const INSIGHTS_BLOG_POSTS_PER_PAGE = 12;
export const domainPrefix = 'https://www.';
export const twitterHandler = '@bestit_ag';

export const blockedSlugsList = ['de-at', 'de', 'layout', 'footer', 'header'];

export const ORGANIZATION_NAME = 'best it';
export const ORGANIZATION_LOGO = '/public/favicon/favicon-512x512.png';
